
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"id\":1,\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true,\"autoprefixer\":true,\"importLoaders\":1}!../../../../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-5baf9776\",\"scoped\":false,\"hasInlineConfig\":true}!sass-loader?{\"sourceMap\":true}!./page-wrap.scss")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-5baf9776\"}!./page-wrap.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./scripts/sky-overlay/page-wrap.vue
// module id = 347
// module chunks = 1